import { PARAMS_LABEL, PHASE_LABEL_FOR_CHARGERS } from './index';
import { renderValue } from '../SchemaDisplay/helpers/node';

export const getLoadLabels = ({
  presentLoadPhA = null,
  presentLoadPhB = null,
  presentLoadPhC = null,
}, isCharger = false) => {
  const labels = isCharger ? PHASE_LABEL_FOR_CHARGERS : PARAMS_LABEL;

  return [
    { label: labels.presentLoadPhA, value: renderValue(presentLoadPhA, 'A') },
    { label: labels.presentLoadPhB, value: renderValue(presentLoadPhB, 'A') },
    { label: labels.presentLoadPhC, value: renderValue(presentLoadPhC, 'A') },
  ];
};

export const getPowerLabels = ({
  presentPowerPhA = null,
  presentPowerPhB = null,
  presentPowerPhC = null,
}, isCharger = false) => {
  const labels = isCharger ? PHASE_LABEL_FOR_CHARGERS : PARAMS_LABEL;

  return [
    { label: labels.presentPowerPhA, value: renderValue(presentPowerPhA, 'kW') },
    { label: labels.presentPowerPhB, value: renderValue(presentPowerPhB, 'kW') },
    { label: labels.presentPowerPhC, value: renderValue(presentPowerPhC, 'kW') },
  ];
};

export const renderPhasesParams = (
  {
    presentLoadPhA = null,
    presentLoadPhB = null,
    presentLoadPhC = null,
    presentPowerPhA = null,
    presentPowerPhB = null,
    presentPowerPhC = null,
    presentVoltagePhA = null,
    presentVoltagePhB = null,
    presentVoltagePhC = null,
    sessionEnergy = null,
  },
  isCharger = false,
) => {
  const labels = isCharger ? PHASE_LABEL_FOR_CHARGERS : PARAMS_LABEL;
  const baseFields = [
    { label: labels.presentLoadPhA, value: renderValue(presentLoadPhA, 'A') },
    { label: labels.presentLoadPhB, value: renderValue(presentLoadPhB, 'A') },
    { label: labels.presentLoadPhC, value: renderValue(presentLoadPhC, 'A') },
    { label: labels.presentPowerPhA, value: renderValue(presentPowerPhA, 'kW') },
    { label: labels.presentPowerPhB, value: renderValue(presentPowerPhB, 'kW') },
    { label: labels.presentPowerPhC, value: renderValue(presentPowerPhC, 'kW') },
  ];

  if (isCharger) {
    baseFields.push(
      { label: labels.presentVoltagePhA, value: renderValue(presentVoltagePhA, 'V') },
      { label: labels.presentVoltagePhB, value: renderValue(presentVoltagePhB, 'V') },
      { label: labels.presentVoltagePhC, value: renderValue(presentVoltagePhC, 'V') },
      { label: PARAMS_LABEL.sessionEnergy, value: renderValue(sessionEnergy, 'kWh') },
    );
  }

  return baseFields;
};
